export const LOAD_CHART = 'LOAD_CHART';
export const LOAD_CHART_SUCCESS = 'LOAD_CHART_SUCCESS';
export const LOAD_CHART_FAILURE = 'LOAD_CHART_FAILURE';
export const LINE_CHART = 'LINE_CHART';
export const LINE_CHART_SUCCESS = 'LINE_CHART_SUCCESS';
export const LINE_CHART_FAILURE = 'LINE_CHART_FAILURE';
export const CANDLESTICK_CHART = 'CANDLESTICK_CHART';
export const CANDLESTICK_CHART_SUCCESS = 'CANDLESTICK_CHART_SUCCESS';
export const CANDLESTICK_CHART_FAILURE = 'CANDLESTICK_CHART_FAILURE';
export const HISTORICAL_CHART= 'HISTORICAL_CHART';
export const HISTORICAL_CHART_SUCCESS= 'HISTORICAL_CHART_SUCCESS';
export const HISTORICAL_CHART_FAILURE= 'HISTORICAL_CHART_FAILURE';
export const LOCAL_STORAGE_UPDATED = 'LOCAL_STORAGE_UPDATED';
